import { inject, Injectable } from '@angular/core';
import { OccConfig } from '@spartacus/core';
import { environment as localEnv } from '../environments/environment';
import { environment as devEnv } from '../environments/environment.dev';
import { environment as stageEnv } from '../environments/environment.staging';
import { environment as prodEnv } from '../environments/environment.prod';
@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  config = inject(OccConfig);
  getConfig(): EnvironmentModel {
    let env;
    if (this.config?.backend?.occ?.baseUrl?.includes('d2')) {
      env = devEnv;
    } else if (this.config?.backend?.occ?.baseUrl?.includes('s1')) {
      env = stageEnv;
    } else if (this.config?.backend?.occ?.baseUrl?.includes('p1')) {
      env = prodEnv;
    } else {
      env = localEnv;
    }
    return env;
  }
}

export interface EnvironmentModel {
  production: boolean;
  googleReCaptchaKey: string;
  baseUrl: string;
}
